import { useEffect, useState } from 'react';
import './App.css';
import {Puzzle} from './Puzzle';
import {getLastOpenPuzzle} from './api';
import {defaultDimensions} from './constants';
import {gdSdk} from './gd-sdk';
import {patternsFoundSingleton} from './puzzle-service/patterns-found-singleton';
import {Loading} from './Loading';
import {socketApi} from './puzzle-service/socket-api';
/* import {SidebarComponent} from './SidebarComponent'; */


export const App = ()=>{
    const [clearCurrentPuzzle,setClearCurrentPuzzle] = useState(false);
    const [dimensions,setDimensions] = useState();
    /* const [sidebarVisible,setSidebarVisible] = useState(false); */
    const [showSpinner,setShowSpinner] = useState(false);
    
    const getNewPuzzleHandler = async(rows,cols)=>{

        console.log('GET NEW PUZZLE!!!!');

        console.log('showing spinner');
        setShowSpinner(true);

        const afterShowAd = ()=>{
            //setShowSpinner(false);
            patternsFoundSingleton.clear();
            setClearCurrentPuzzle(true);
            setDimensions({rows,cols});
        };

        const onGamePause =()=>{
            setShowSpinner(false);
        };

        const onGameStart = ()=>{
            //console.log('hiding spinner');
            setShowSpinner(false);
        };

        const onAdError = ()=>{
            setShowSpinner(false);
            afterShowAd();
        };

        try{          
                       
            gdSdk.onceAdError(onAdError);
            gdSdk.onceGameStart(onGameStart);
            gdSdk.onceGamePause(onGamePause);

            await gdSdk.showAdCore(true);
            //console.log('puzzle show ad call success');
        }catch(e){
            console.log('Error on get new puzzle show ad',e);
        }finally{
            gdSdk.removeAdErrorListener(onAdError);
            gdSdk.removeGamePauseListener(onGamePause);
            gdSdk.removeGameStartListener(onGameStart);
        }

        afterShowAd();
        
    };

    useEffect(()=>{
        if(clearCurrentPuzzle) setClearCurrentPuzzle(false);
    },[clearCurrentPuzzle]);

    useEffect(()=>{
        socketApi.initialize();
    },[]);

    useEffect(()=>{

        const puzzleUser = localStorage.getItem('puzzle-user');
        
        if(!puzzleUser) {
            const {HORIZONTAL,VERTICAL} = defaultDimensions;
            setDimensions({rows:HORIZONTAL,cols:VERTICAL});
            return;
        }

        (async()=>{
            const lastOpenPuzzle = await getLastOpenPuzzle(puzzleUser);
            //console.log('last open puzzle',lastOpenPuzzle);
            if(lastOpenPuzzle){
                const {rows,cols} = lastOpenPuzzle.job;
                //console.log('setting dimensions,with open puzzle',rows,cols);
                setDimensions({rows,cols});
            }else{
                const {HORIZONTAL,VERTICAL} = defaultDimensions;
                setClearCurrentPuzzle(true);
                //console.log('setting dimensions,no open puzzle',HORIZONTAL,VERTICAL);
                setDimensions({rows:HORIZONTAL,cols:VERTICAL});
            }

            

        })();
    },[]);  

    
    /* const onSidebarOpen = ()=>{
        setSidebarVisible(true);
    } */

    return(
        <>
          {showSpinner ? <Loading></Loading>:null}        
          {clearCurrentPuzzle ? null : 
            dimensions ? 
                /* (<SidebarComponent visible={sidebarVisible} onHide={()=>{setSidebarVisible(false)}}>
                    <Puzzle getNewPuzzleHandler={getNewPuzzleHandler}
                        onSidebarOpen = {onSidebarOpen} 
                        rows={dimensions.rows} cols={dimensions.cols}>
                    </Puzzle>
                </SidebarComponent>) */  
                <Puzzle getNewPuzzleHandler={getNewPuzzleHandler}
                    //onSidebarOpen = {onSidebarOpen} 
                    rows={dimensions.rows} cols={dimensions.cols}>
                </Puzzle>
                : null
          }
        </>
    );     
   
    
};